<template>
  <div>
    <div>
      <el-checkbox v-model="enable">启用</el-checkbox>
    </div>
    <div v-show="enable">
      <el-table :data="dataSource">
        <el-table-column prop="del" label="操作" :width="50">
          <template slot-scope="{ row }">
            <el-link @click="handleDel(row)">删除</el-link>
          </template>
        </el-table-column>
        <el-table-column
          v-for="col in ccolumns"
          :key="col.name"
          :width="col.name === 'sizeModelTry_image' ? 120 : ''"
          :prop="col.name"
          :label="col.label"
        >
          <template slot="header">
            <span v-if="col.rules && col.rules.requiredRule === 'true'" style="color: red">*</span>
            {{ col.label }}
          </template>
          <template slot-scope="{ row, $index }">
            <template v-if="col.name === 'sizeModelTry_image'">
              <!-- 图片上传 -->
              <div style="padding: 6px 0">
                <ImgUpload
                  :width="80"
                  :height="80"
                  :size="100"
                  :file="row[col.name].defaultValue || ''"
                  :isSingle="true"
                  @upload-success="v => handleUploadImg(v, row, col)"
                  @del="handleUploadImg('', row, col)"
                />
                <div v-if="errors[col.name + '_' + $index]" style="color: red">{{ errors[col.name + '_' + $index] }}</div>
              </div>
            </template>
            <template v-else>
              <el-input
                v-model="row[col.name].defaultValue"
                :regexp="col.rules && col.rules.regexRule ? '^' + col.rules.regexRule + '$' : undefined"
                show-word-limit
                :maxlength="col.rules && col.rules.maxLengthRule ? col.rules.maxLengthRule : undefined"
                @change="v => handleInputValidate(v, row, col)"
              />
              <div v-if="errors[col.name + '_' + $index]" style="color: red">{{ errors[col.name + '_' + $index] }}</div>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-button @click="handleAdd">新增</el-button>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload.vue';

const itemProps = {
  id: null,
  dataId: null,
  defaultValue: null,
  valueDisplayName: null,
  valueType: null,
  rules: null,
  options: null,
  children: null,
  extendValue: null,
  properties: null,
  propType: null,
  label: null,
  name: null,
};

export default {
  name: 'model-try',
  components: { ImgUpload },
  props: ['props'],
  computed: {
    ccolumns({ props }) {
      return props?.columns?.children || [];
    },
  },
  watch: {
    props: {
      immediate: true,
      handler(v) {
        let data = [];
        (v?.value?.children || []).forEach(item => {
          if (item.children?.length) {
            // 创建一个包含所有 ccolumns 列的完整行对象
            let row = {};
            
            // 首先初始化所有 ccolumns 中定义的列
            this.ccolumns.forEach(col => {
              row[col.name] = {
                ...itemProps,
                type: col.type || 'INPUT',
                ...col,
                defaultValue: '',
              };
            });
            
            // 然后用实际数据覆盖对应的列
            item.children.forEach(cur => {
              if(cur.name === 'sizeModelTry_image') {
                const imagesItem = cur.children?.find(child => child.name === 'images')
                if(imagesItem && imagesItem.children?.length) {
                  row[cur.name].defaultValue = imagesItem.children[0].defaultValue || ''
                } else {
                  row[cur.name].defaultValue = cur.defaultValue || ''
                }
              } else if(row[cur.name]) {
                row[cur.name] = { ...row[cur.name], ...cur };
              }
            });
            data.push(row);
          }
        });
        this.dataSource = data;
        this.enable = !!data.length;
        this.initErrors();
      },
    },
  },
  data() {
    return {
      dataSource: [],
      errors: {},
      enable: false,
    };
  },
  methods: {
    initErrors(data) {
      // 初始规则校验 数据来源不一定都正确
      (data || this.dataSource).forEach(row => {
        (this.props?.columns?.children || []).forEach(col => {
          // 确保行中存在该列的数据
          if (row[col.name]) {
            this.handleInputValidate(row[col.name]?.defaultValue, row, col);
          }
        });
      });
    },
    handleUploadImg(url, row, col) {
      row[col.name].defaultValue = url;
      this.handleInputValidate(url, row, col);
    },
    handleInputValidate(val, row, col) {
      if (!col.rules || val === void 0) return;
      // 必填项
      let rule = col.rules;
      let rowIdx = this.dataSource.indexOf(row);
      let key = `${col.name}_${rowIdx}`;
      if (rule.requiredRule === 'true' && !val) {
        this.$set(this.errors, key, '不能为空');
      } else if (val && rule.maxValueRule && rule.minValueRule && (val * 1 > rule.maxValueRule * 1 || val * 1 < rule.minValueRule * 1)) {
        // 校验最大最小
        this.$set(this.errors, key, `数值范围在${rule.minValueRule}-${rule.maxValueRule}之间`);
      } else {
        if (this.errors[key]) {
          this.errors[key] = '';
          delete this.errors[key];
        }
      }
    },
    handleAdd() {
      let row = this.ccolumns.reduce((acc, cur) => {
        return {
          ...acc,
          [cur.name]: {
            ...itemProps,
            type: 'INPUT',
            name: cur.name,
            label: cur.label,
          },
        };
      }, {});
      this.dataSource.push(row);
      this.initErrors([row]);
    },
    handleDel(row) {
      let idx = this.dataSource.indexOf(row);
      this.dataSource.splice(idx, 1);
      this.errors = {};
      this.initErrors();
    },
    validate() {
      if (!this.enable || Object.keys(this.errors).length === 0) {
        return true;
      } else {
        this.$message.warning('请完善模特试穿信息');
        return false;
      }
    },
    method_getData() {
      if (!this.validate()) {
        return false;
      }
      return {
        ...itemProps,
        label: '尺码模特试穿表',
        name: 'size_model_try',
        ...(this.props?.value || {}),
        children: this.enable
          ? this.dataSource.map(item => {
            const children = Object.values(item)
            children.forEach(child => {
              if(child.name === "sizeModelTry_image" && child.children?.length) {
                child.type = 'COMPLEX'
                child.children = [{
                  "name": "images",
                  "label": "上传图片",
                  "type": "MULTICOMPLEX",
                  "children": [
                    {
                      "name": "url",
                      "label": "图片地址",
                      "type": "INPUT",
                      "defaultValue": child.defaultValue,
                    }
                  ],
                }];
                child.defaultValue = null
              }
            })
            return {
              ...itemProps,
              type: 'COMPLEX',
              children,
            }
          })
          : [],
      };
    },
  },
};
</script>
